<script setup lang="ts">
useSeoMeta({
  title: 'Contacto - Granados Pinturas Industriales',
  description: 'Contáctenos para cotizaciones y consultas sobre pinturas industriales.'
})
</script>

<template>
  <div>
    <UContainer class="py-12">
      <div class="max-w-3xl mx-auto">
        <h1 class="text-3xl font-bold text-gray-900 dark:text-white mb-4 text-center">
          Contáctenos
        </h1>
        <p class="text-gray-600 dark:text-gray-400 text-center mb-12">
          Estamos aquí para ayudarle con sus necesidades de pinturas industriales.
        </p>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
          <!-- Contact Info -->
          <UCard>
            <template #header>
              <h2 class="font-semibold text-gray-900 dark:text-white">
                Información de Contacto
              </h2>
            </template>

            <div class="space-y-6">
              <div class="flex items-start gap-4">
                <div class="w-10 h-10 bg-primary-100 dark:bg-primary-900 rounded-lg flex items-center justify-center shrink-0">
                  <UIcon name="i-heroicons-envelope" class="w-5 h-5 text-primary-500" />
                </div>
                <div>
                  <p class="font-medium text-gray-900 dark:text-white">Email</p>
                  <a
                    href="mailto:pinturasacoxpa@gmail.com"
                    class="text-gray-600 dark:text-gray-400 hover:text-primary-500 transition-colors"
                  >
                    pinturasacoxpa@gmail.com
                  </a>
                </div>
              </div>

              <div class="flex items-start gap-4">
                <div class="w-10 h-10 bg-primary-100 dark:bg-primary-900 rounded-lg flex items-center justify-center shrink-0">
                  <UIcon name="i-heroicons-phone" class="w-5 h-5 text-primary-500" />
                </div>
                <div>
                  <p class="font-medium text-gray-900 dark:text-white">Teléfono</p>
                  <a
                    href="tel:+525582960319"
                    class="text-gray-600 dark:text-gray-400 hover:text-primary-500 transition-colors"
                  >
                    +52 55 8296 0319
                  </a>
                </div>
              </div>

              <div class="flex items-start gap-4">
                <div class="w-10 h-10 bg-primary-100 dark:bg-primary-900 rounded-lg flex items-center justify-center shrink-0">
                  <UIcon name="i-heroicons-map-pin" class="w-5 h-5 text-primary-500" />
                </div>
                <div>
                  <p class="font-medium text-gray-900 dark:text-white">Ubicación</p>
                  <p class="text-gray-600 dark:text-gray-400">
                    Ciudad de México, México
                  </p>
                </div>
              </div>

              <div class="flex items-start gap-4">
                <div class="w-10 h-10 bg-primary-100 dark:bg-primary-900 rounded-lg flex items-center justify-center shrink-0">
                  <UIcon name="i-heroicons-clock" class="w-5 h-5 text-primary-500" />
                </div>
                <div>
                  <p class="font-medium text-gray-900 dark:text-white">Horario</p>
                  <p class="text-gray-600 dark:text-gray-400">
                    Lunes a Viernes: 9:00 - 18:00<br>
                    Sábado: 9:00 - 14:00
                  </p>
                </div>
              </div>
            </div>
          </UCard>

          <!-- Quick Quote -->
          <UCard>
            <template #header>
              <h2 class="font-semibold text-gray-900 dark:text-white">
                Solicite una Cotización
              </h2>
            </template>

            <div class="text-center py-6">
              <UIcon
                name="i-heroicons-clipboard-document-list"
                class="w-16 h-16 mx-auto text-primary-500 mb-4"
              />
              <p class="text-gray-600 dark:text-gray-400 mb-6">
                Explore nuestro catálogo y agregue los productos que necesita
                para recibir una cotización instantánea.
              </p>
              <UButton to="/" color="primary" size="lg">
                Ver Catálogo
              </UButton>
            </div>
          </UCard>
        </div>

        <!-- About -->
        <UCard class="mt-8">
          <div class="text-center">
            <h2 class="text-xl font-semibold text-gray-900 dark:text-white mb-4">
              Soluciones de Pintura Industrial
            </h2>
            <p class="text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
              Granados Pinturas Industriales ofrece soluciones de pintura
              industrial de alta calidad para flotillas comerciales, industria
              manufacturera y proyectos especiales en México.
            </p>
          </div>
        </UCard>
      </div>
    </UContainer>
  </div>
</template>
